import { NavigationGuardNext, Route } from 'vue-router';
import { loggedIn } from '@/ui/auth/auth';
import { NamedLocation } from '../types';

export function guardGuestRoutes(
  to: Route,
  from: Route,
  next: NavigationGuardNext,
): void {
  if (loggedIn.value && to.name !== 'impersonate') {
    const redirectTo: NamedLocation = { name: 'home' };
    next(redirectTo);
  }
  next();
}
